import '@babel/polyfill'
import './plugins/vuetify'
import Vue from 'vue'
import App from './App.vue'
import store from './store/index'
import Header from './components/Header'
import Navigation from './components/Navigation'
import AlertBox from './components/AlertBox.vue'
import DialogBox from './components/DialogBox.vue'
import router from './router'
import VueSweetalert2 from 'vue-sweetalert2'
import 'chart.js'
import 'hchs-vue-charts'
import '@mdi/font/css/materialdesignicons.css'
import 'babel-polyfill'  
import JsonExcel from 'vue-json-excel'

Vue.use(window.VueCharts)
Vue.use(VueSweetalert2)

Vue.config.productionTip = false

Vue.component(Header.name, Header)
Vue.component(Navigation.name, Navigation)
Vue.component(AlertBox.name, AlertBox)
Vue.component(DialogBox.name, DialogBox)
Vue.component('downloadExcel', JsonExcel)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
